import type { IModule } from "../security/models/module-model";

export default <IModule>{
  routes: [
    {
      path: "/module/timeSchedule",
      name: "timeSchedule",
      meta: { requiresAuth: true, title: "routes.workSchedule" },
      component: () => import("./main.vue")
    }
  ]
};
